// Global packages and components
import { inputRadioClasses } from '~/utils'
import { clsx } from 'clsx'

// Types
import type { ReactNode } from 'react'

interface ButtonProps {
  name: string
  id?: string
  value: string
  checked?: boolean
  disabled?: boolean
  children?: ReactNode
  required?: boolean
  error?: string
  onChange?: (e: string) => void
}

const FulfilmentButton = ({
  name,
  id,
  value,
  checked,
  disabled,
  children,
  required,
  onChange,
}: ButtonProps) => (
  <label
    className={clsx('flex justify-between gap-4 rounded-lg border p-3 sm:p-4', {
      'cursor-pointer': !disabled,
      'cursor-not-allowed': disabled,
      'bg-[#E9FAF2]': checked,
      'bg-white': !checked,
      'border-teal-green': checked,
      'border-neutral-300': !checked,
    })}
  >
    <div
      className={clsx('flex gap-4', {
        'cursor-pointer': !disabled,
        'pointer-events-none cursor-not-allowed text-gray-300': disabled,
      })}
    >
      {children}
    </div>
    <div className="shrink-0">
      <input
        type="radio"
        name={name}
        id={id ?? value}
        required={required}
        value={value}
        checked={checked}
        onChange={() => (onChange ? onChange(value) : undefined)}
        className={inputRadioClasses({ disabled })}
      />
    </div>
  </label>
)

export default FulfilmentButton
